import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from '../shared/AnimatedSection';
import { Sign } from '../../data/signs';
interface SignDesbloqueoProps {
  sign: Sign;
}
export function SignDesbloqueo({
  sign
}: SignDesbloqueoProps) {
  return <section className="relative w-full py-24 md:py-32 px-5 md:px-6 overflow-hidden bg-cosmic-black" data-id="element-869">
      {/* Atmospheric backdrop */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-870">
        <div className="absolute inset-0" style={{
        background: `radial-gradient(ellipse at 30% 30%, ${sign.colors.primary}15 0%, transparent 60%)`
      }} data-id="element-871" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, #050508 0%, rgba(5,5,8,0.4) 50%, #050508 100%)'
      }} data-id="element-872" />
      </div>

      {/* Floating embers */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-873">
        {[...Array(8)].map((_, i) => <motion.div key={i} className="absolute w-[2px] h-[2px] rounded-full" style={{
        backgroundColor: i % 2 === 0 ? sign.colors.primary : sign.colors.accent,
        left: `${i * 13 % 100}%`,
        top: `${15 + i * 11 % 70}%`,
        boxShadow: `0 0 8px ${i % 2 === 0 ? sign.colors.primary : sign.colors.accent}`
      }} animate={{
        y: [-10, -40, -10],
        opacity: [0.15, 0.5, 0.15]
      }} transition={{
        duration: 6 + i % 4,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: i * 0.4
      }} data-id="element-874" />)}
      </div>

      <div className="relative z-10 container mx-auto max-w-5xl" data-id="element-875">
        {/* Header */}
        <AnimatedSection data-id="element-876">
          <div className="text-center mb-12 md:mb-16 px-2" data-id="element-877">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-5 md:mb-6 leading-tight max-w-4xl mx-auto" style={{
            textShadow: `0 0 30px ${sign.colors.primary}40, 0 4px 30px rgba(0,0,0,0.7)`
          }} data-id="element-878">
              Lo que desbloquearás dentro de tu Reino
            </h2>

            <p className="max-w-2xl mx-auto text-base md:text-lg lg:text-xl font-serif italic leading-relaxed px-2" style={{
            color: sign.colors.accent
          }} data-id="element-879">
              Esto no es solo una lectura.
              <br data-id="element-880" />
              Es una experiencia diseñada para ayudarte a comprender patrones
              internos que muchas veces repites sin darte cuenta.
            </p>
          </div>
        </AnimatedSection>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 lg:gap-6" data-id="element-881">
          {sign.content.desbloqueoItems.map((item, i) => <AnimatedSection key={i} delay={0.1 + i * 0.05} data-id="element-882">
              <div className="relative rounded-xl px-5 py-5 md:px-6 md:py-6 backdrop-blur-sm h-full flex items-start gap-4" style={{
            background: 'linear-gradient(135deg, rgba(12,12,20,0.7) 0%, rgba(8,8,14,0.65) 100%)',
            border: `1px solid ${sign.colors.primary}30`,
            boxShadow: `0 0 20px ${sign.colors.primary}05, inset 0 0 15px ${sign.colors.primary}05`
          }} data-id="element-883">
                <span className="flex-shrink-0 mt-0.5 text-lg md:text-xl font-bold leading-none" style={{
              color: sign.colors.primary,
              textShadow: `0 0 10px ${sign.colors.primary}80`
            }} aria-hidden="true" data-id="element-884">
                  ✔
                </span>
                <p className="text-base md:text-lg font-serif leading-snug" style={{
              color: '#F5F0E1'
            }} data-id="element-885">
                  {item}
                </p>
              </div>
            </AnimatedSection>)}
        </div>

        {/* Closing paragraph */}
        <AnimatedSection delay={0.4} data-id="element-886">
          <div className="mt-14 md:mt-20 text-center px-2" data-id="element-887">
            <div className="flex items-center justify-center mb-6" data-id="element-888">
              <div className="h-px w-12" style={{
              background: `linear-gradient(90deg, transparent, ${sign.colors.primary}80)`
            }} data-id="element-889" />
              <div className="mx-4 w-1.5 h-1.5 rotate-45" style={{
              backgroundColor: sign.colors.primary,
              boxShadow: `0 0 8px ${sign.colors.primary}`
            }} data-id="element-890" />
              <div className="h-px w-12" style={{
              background: `linear-gradient(90deg, ${sign.colors.primary}80, transparent)`
            }} data-id="element-891" />
            </div>

            <p className="max-w-2xl mx-auto text-base md:text-lg lg:text-xl font-serif italic leading-relaxed" style={{
            color: '#F5F0E1',
            textShadow: `0 0 20px ${sign.colors.primary}40`
          }} data-id="element-892">
              Todo esto dentro de una experiencia privada e inmersiva creada
              alrededor de tu identidad emocional.
            </p>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}